import { render } from "./EmailAddressModal.vue?vue&type=template&id=1981d569&scoped=true&ts=true"
import script from "./EmailAddressModal.vue?vue&type=script&lang=ts"
export * from "./EmailAddressModal.vue?vue&type=script&lang=ts"

import "./EmailAddressModal.vue?vue&type=style&index=0&id=1981d569&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1981d569"]])

export default __exports__